import React, { useEffect, useState } from 'react';
import { Container, Row, Col, Card, Button, Form, Offcanvas, Modal, Image, Alert } from 'react-bootstrap';
import countryService from '../services/countryService';
import { useNavigate } from 'react-router-dom';  // En üste ekleyin
import config from '../../config';

const ExhibitionsManagePage = () => {
  const navigate = useNavigate();  // useNavigate hook'unu ekleyin
  const [countries, setCountries] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [showDrawer, setShowDrawer] = useState(false);
  const [formData, setFormData] = useState({
    name: '',
    coverImage: null
  });
  const [imagePreview, setImagePreview] = useState(null);

  // Add these handler functions
  const handleDrawerShow = () => setShowDrawer(true);
  const handleDrawerClose = () => {
    setShowDrawer(false);
    setFormData({ name: '', coverImage: null });
    setImagePreview(null);
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    console.log("File selected:", file);
    console.log("File details:", file ? { name: file.name, size: file.size, type: file.type } : "No file");
    
    if (file) {
      setFormData(prevData => {
        const newData = {
          ...prevData,
          coverImage: file
        };
        console.log("New formData with image:", newData);
        return newData;
      });
      
      // Create preview URL
      const reader = new FileReader();
      reader.onload = (e) => {
        setImagePreview(e.target.result);
      };
      reader.readAsDataURL(file);
    } else {
      console.log("No file selected");
    }
  };

  const handleCountryClick = (countryId) => {
    // window.location.href yerine navigate kullan
    navigate(`/admin/exhibitions/country/${countryId}`);
  };

  const loadCountries = async () => {
    try {
      const response = await countryService.getCountries();
      console.log('API Response:', response); // Gelen veriyi kontrol edelim
      
      // Yeni format: {data: [...], log: {...}, message: '...'}
      let countriesData = response;
      
      // Eğer response.data varsa (yeni format), onu kullan
      if (response && response.data && Array.isArray(response.data)) {
        countriesData = response.data;
        console.log('Live Deployment Log:', response.log);
        console.log('Server:', response.log?.server);
        console.log('Timestamp:', response.log?.timestamp);
      }
      
      console.log('Countries data:', countriesData);
      console.log('Data type:', typeof countriesData);
      console.log('Is array:', Array.isArray(countriesData));
      
      // Array kontrolü
      if (Array.isArray(countriesData)) {
        setCountries(countriesData);
      } else {
        console.error('Data is not an array:', countriesData);
        setCountries([]);
        setError('Invalid data format received');
      }
      setError(null);
    } catch (error) {
      console.error('Failed to load countries:', error);
      setError('Failed to load countries');
      setCountries([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadCountries();
  }, []);
  const handleSubmit = async (e) => {
    e.preventDefault();
    
    const name = formData.name;
    const file = formData.coverImage;
    
    console.log("=== SUBMIT DEBUG ===");
    console.log("formData.name:", formData.name);
    console.log("name variable:", name);
    console.log("formData.coverImage:", formData.coverImage);
    console.log("file variable:", file);
    console.log("file instanceof File:", file instanceof File);
    
    if (file instanceof File) {
      console.log("File details:", {
        name: file.name,
        size: file.size,
        type: file.type
      });
    }
    
    if (!name) {
      alert('Please enter a country name');
      return;
    }
    
    try {
      const formDataToSend = new FormData();
      formDataToSend.append('name', name);
      
      console.log("FormData entries (before image):");
      for (let [key, value] of formDataToSend.entries()) {
        console.log(key, value);
      }
      
      if (file && file instanceof File) {
        console.log("Adding file to FormData:", file);
        formDataToSend.append('coverImage', file);
      } else {
        console.log("No valid file to add");
      }
      
      console.log("FormData entries (after image):");
      for (let [key, value] of formDataToSend.entries()) {
        console.log(key, value);
        if (value instanceof File) {
          console.log("  - File details:", value.name, value.size, value.type);
        }
      }
      
      const result = await countryService.addCountry(formDataToSend);
      handleDrawerClose();
      loadCountries();
    } catch (error) {
      console.error('Error:', error);
      alert('Failed to add country: ' + error.message);
    }
  };
 
  // Add new state for delete modal
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [countryToDelete, setCountryToDelete] = useState(null);

  // Update existing handleDelete function
  const handleDelete = async (e, countryId) => {
    e.stopPropagation();
    setCountryToDelete(countryId);
    setShowDeleteModal(true);
  };

  // Add confirmDelete function
  const confirmDelete = async () => {
    try {
      await countryService.deleteCountry(countryToDelete);
      loadCountries();
      setShowDeleteModal(false);
    } catch (error) {
      console.error('Failed to delete country:', error);
    }
  };

  return (
    <Container fluid className="mt-5">
      <div className="d-flex justify-content-between align-items-center mb-4">
        <h2>Exhibitions by Country</h2>
        <Button variant="primary" onClick={handleDrawerShow}>
          Add New Country
        </Button>
      </div>

      <Row xs={1} md={2} lg={3} className="g-4">
        {Array.isArray(countries) && countries.length > 0 ? (
          countries.map((country) => (
            <Col key={country.id}>
              <Card 
                className="h-100 shadow-sm hover-effect" 
                onClick={() => handleCountryClick(country.id)}
                style={{ cursor: 'pointer' }}
              >
                <Card.Img 
                  variant="top" 
                  src={country.cover_image ? (() => {
                    // Eğer path zaten /api ile başlıyorsa, sadece domain ekle
                    if (country.cover_image.startsWith('/api/')) {
                      return `https://tekstas.com${country.cover_image}`;
                    }
                    // Eğer path /uploads ile başlıyorsa, API_URL ile birleştir
                    else if (country.cover_image.startsWith('/uploads/')) {
                      return `${config.API_URL}${country.cover_image}`;
                    }
                    // Diğer durumlar için API_URL ile birleştir
                    else {
                      return `${config.API_URL}${country.cover_image}`;
                    }
                  })() : null}
                  style={{ 
                    height: '200px', 
                    objectFit: 'cover' 
                  }}
                  onError={(e) => {
                    e.target.style.display = 'none';
                  }}
                />
                <Card.Body>
                  <div className="d-flex justify-content-between align-items-start">
                    <div>
                      <Card.Title>{country.name}</Card.Title>
                      <Card.Text>
                        Total Photos: {country.totalPhotos || 0}
                      </Card.Text>
                    </div>
                    <Button 
                      variant="danger" 
                      size="sm"
                      onClick={(e) => handleDelete(e, country.id)}
                    >
                      Delete
                    </Button>
                  </div>
                </Card.Body>
              </Card>
            </Col>
          ))
        ) : (
          <Col xs={12}>
            <div className="text-center">
              {loading ? (
                <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '200px' }}>
                  <div className="spinner-border text-primary" role="status">
                    <span className="visually-hidden">Loading...</span>
                  </div>
                </div>
              ) : error ? (
                <div className="alert alert-danger d-flex align-items-center" role="alert" style={{ 
                  width: '100%', 
                }}>
                  <svg className="bi flex-shrink-0 me-2" width="24" height="24" role="img" aria-label="Danger:">
                    <use href="#exclamation-triangle-fill"/>
                  </svg>
                  <div>{error}</div>
                </div>
              ) : (
                <div className="alert alert-info d-flex align-items-center shadow-sm" role="alert" style={{ 
                  width: '100%', 
                  margin: '50px 0',
                  borderRadius: '12px',
                  border: 'none',
                  backgroundColor: "rgb(255 229 229)",
                  border:"1px solid rgb(255 153 153)",
                  color: '#6c757d'
                }}>
                  <div className="text-center w-100">
                    <svg className="bi mb-3" width="48" height="48" fill="currentColor" viewBox="0 0 16 16">
                      <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/>
                      <path d="M8 4a.905.905 0 0 0-.9.995l.35 3.507a.552.552 0 0 0 1.1 0l.35-3.507A.905.905 0 0 0 8 4zm.002 6a1 1 0 1 0 0 2 1 1 0 0 0 0-2z"/>
                    </svg>
                    <h5 className="mb-2">No Countries Found</h5>
                    <p className="mb-3">There are no countries added yet. Start by adding your first country to organize exhibitions.</p>
                    <Button variant="primary" onClick={handleDrawerShow}>
                      <svg className="bi me-2" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                        <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3a.5.5 0 0 1 .5-.5z"/>
                      </svg>
                      Add First Country
                    </Button>
                  </div>
                </div>
              )}
            </div>
          </Col>
        )}
      </Row>

      {/* Add Country Drawer */}
      <Offcanvas show={showDrawer} onHide={handleDrawerClose} placement="end">
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>Add New Country</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <Form onSubmit={handleSubmit}>
            <Form.Group className="mb-3">
              <Form.Label>Country Name</Form.Label>
              <Form.Control 
                type="text" 
                name="name" // Burada 'name' olarak tanımlı olmalı
                value={formData.name}
                onChange={handleInputChange}
                placeholder="Enter country name" 
                required
              />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Cover Image</Form.Label>
              <Form.Control 
                type="file" 
                onChange={handleImageChange}
                accept="image/*"
                required
              />
            </Form.Group>

            {/* Image Preview */}
            {imagePreview && (
              <Form.Group className="mb-3">
                <Form.Label>Image Preview</Form.Label>
                <div className="text-center">
                  <Image 
                    src={imagePreview} 
                    alt="Preview" 
                    style={{ 
                      maxWidth: '100%', 
                      maxHeight: '200px', 
                      objectFit: 'cover',
                      border: '1px solid #ddd',
                      borderRadius: '4px'
                    }}
                    thumbnail
                  />
                </div>
              </Form.Group>
            )}

            <div className="d-grid gap-2">
              <Button variant="primary" type="submit">
                Save Country
              </Button>
            </div>
          </Form>
        </Offcanvas.Body>
      </Offcanvas>

      {/* Add Delete Modal before closing Container */}
      <Modal show={showDeleteModal} onHide={() => setShowDeleteModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Delete Confirmation</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>Warning: Deleting this country will also delete all associated photos and exhibitions.</p>
          <p>Are you sure you want to proceed with deletion?</p>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowDeleteModal(false)}>
            Cancel
          </Button>
          <Button variant="danger" onClick={confirmDelete}>
            Delete Country
          </Button>
        </Modal.Footer>
      </Modal>
    </Container>
  );
};

export default ExhibitionsManagePage;
